import { render } from "./OnboardingThirdStep.vue?vue&type=template&id=62454975&scoped=true&ts=true"
import script from "./OnboardingThirdStep.vue?vue&type=script&lang=ts"
export * from "./OnboardingThirdStep.vue?vue&type=script&lang=ts"

import "./OnboardingThirdStep.vue?vue&type=style&index=0&id=62454975&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62454975"]])

export default __exports__